import React from "react";

export const FlimpLogo = () => {
    return (
        <svg
            width="18"
            height="28"
            viewBox="0 0 18 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.68592 9.01012H6.94889C10.6913 9.01012 14.2628 7.81084 17.2898 5.54077L13.9674 0.829285C11.914 2.37123 9.4915 3.18503 6.95354 3.18503H6.69053H0.710266V27.1707H6.69053V18.2285H16.0255V12.4034H6.68592V9.01012Z"
                fill="#08212D"
            />
        </svg>
    );
};
